export interface IToasterServiceStrategy {
  show: (errorCode: string, options?: object) => void;
  hide: () => void;
}

export class ToasterService {
  public static getInstance(): ToasterService {
    if (!ToasterService._instance) {
      ToasterService._instance = new ToasterService();
    }

    return ToasterService._instance;
  }

  private static _instance: ToasterService;
  private _strategy: IToasterServiceStrategy;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}
  public set strategy(value: IToasterServiceStrategy) {
    this._strategy = value;
  }
  public get strategy(): IToasterServiceStrategy {
    if (!this._strategy) {
      throw new Error(
        'affiny-core/services/toaster.ts you cannot call .strategy before configure it. Search ToasterService.configure() method'
      );
    }

    return this._strategy;
  }

  public show(errorCode: string, options?: object) {
    return this.strategy.show(errorCode, options);
  }
  public hide() {
    return this.strategy.hide();
  }
}

export const toasterService = ToasterService.getInstance();
